export default __webpack_public_path__ + "static/media/filt.c20fa948.svg";